import type {ReactNode, MouseEventHandler} from 'react'

interface IndentedPickerButtonProps {
    depth: number
    indent?: number
    basePadding?: number
    className?: string
    onClick?: MouseEventHandler<HTMLButtonElement>
    children?: ReactNode
    'data-testid'?: string
}

export function IndentedPickerButton({
    depth,
    indent = 20,
    basePadding = 12,
    className,
    onClick,
    children,
    'data-testid': testId,
}: IndentedPickerButtonProps) {
    const paddingLeft = depth * indent + basePadding
    return (
        <button
            type="button"
            className={className}
            onClick={onClick}
            style={{paddingLeft: `${paddingLeft}px`}}
            data-testid={testId}
        >
            {children}
        </button>
    )
}
